angular.module('banners', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/service/banners/banners.module.js